import { DAY_OF_WEEK } from 'cube/constants'

import { STATUS_HUMANIZED_TRANSLATION } from 'constants/meetings'

export const MAX_MENU_HEIGHT = window.innerHeight * 0.6

export const dayOfWeekOptions = [
  {
    label: 'Monday',
    value: DAY_OF_WEEK.MON,
  },
  {
    label: 'Tuesday',
    value: DAY_OF_WEEK.TUE,
  },
  {
    label: 'Wednesday',
    value: DAY_OF_WEEK.WED,
  },
  {
    label: 'Thursday',
    value: DAY_OF_WEEK.THU,
  },
  {
    label: 'Friday',
    value: DAY_OF_WEEK.FRI,
  },
  {
    label: 'Saturday',
    value: DAY_OF_WEEK.SAT,
  },
  {
    label: 'Sunday',
    value: DAY_OF_WEEK.SUN,
  },
]

export const routingOutcomeOptions = [
  {
    label: 'Teammate responded',
    value: 'TEAMMATE_RESPONDED',
  },
  {
    label: 'Calendar dropped',
    value: 'CALENDAR_DROP',
  },
  {
    label: 'Ticket created',
    value: 'TICKET_CREATED',
  },
  {
    label: 'Away message sent',
    value: 'AWAY_MESSAGE_SENT',
  },
  {
    label: 'None',
    value: 'NONE',
  },
]

export const meetingOutcomesOptions = Object.keys(
  STATUS_HUMANIZED_TRANSLATION
).map((status) => {
  return {
    value: status,
    label: STATUS_HUMANIZED_TRANSLATION[status],
  }
})
